import {
  List,
  ListItem,
  ListItemText,
  Pagination,
  Card,
  CardContent,
  Stack,
  Typography,
  Chip,
  ListItemIcon,
  Radio,
  Box
} from '@mui/material';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { fDateTimeSuffix } from '../../../utils/formatTime';
import PreviewButtonComponent from '../../team/PreviewButtonComponent';
import SnapshotPreviewModal from '../../team/SnapshotPreviewModal';

const pageSize = 10;
const styles = {
  snapshotList: {
    maxHeight: '50vh',
    overflowY: 'scroll'
  }
};

SnapshotList.propTypes = {
  snapshotList: PropTypes.array,
  setCheckedSnapshot: PropTypes.func
};

SnapshotList.defaultProps = {
  snapshotList: []
};

export default function SnapshotList({ snapshotList, setCheckedSnapshot }) {
  const [page, setPage] = useState(1);
  const [checked, setChecked] = useState(null);

  const handleChange = (_, value) => setPage(value);

  const handleToggle = (snapshot) => () => {
    setChecked(snapshot.name);
    setCheckedSnapshot(snapshot);
  };

  const start = (page - 1) * pageSize;
  const paginated = snapshotList.slice(start, start + pageSize);

  useEffect(() => {
    // set the pagination back to 1 when snapshot list updates
    setPage(1);
  }, [snapshotList]);

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" px={2}>
          <Typography variant="h6">Snapshots List</Typography>
          <Pagination
            count={Math.ceil(snapshotList.length / pageSize)}
            page={page}
            onChange={handleChange}
          />
        </Stack>

        <List sx={styles.snapshotList}>
          {paginated.map((item) => (
            <ListItem
              key={item.name}
              divider
              secondaryAction={
                <Stack spacing={1} alignItems="flex-end">
                  <Box>
                    <PreviewButtonComponent
                      type="text"
                      variant="outlined"
                      data={item}
                      tooltipTitle="Preview Snapshot"
                      ModalComponent={SnapshotPreviewModal}
                      modalProps={{
                        data: item
                      }}
                    />
                  </Box>
                </Stack>
              }
            >
              <ListItemIcon>
                <Radio edge="start" checked={checked === item.name} onChange={handleToggle(item)} />
              </ListItemIcon>
              <ListItemText
                primary={item.name}
                secondary={
                  <Stack spacing={0.5}>
                    <Typography variant="body2">{item.description}</Typography>
                    <Stack direction="row" spacing={1}>
                      <Chip
                        label={`size: ${item.rack_details?.gateway?.size || 'N/A'}`}
                        size="small"
                        color="primary"
                      />
                      {item.global && <Chip label="global" size="small" color="success" />}
                      <Chip
                        label={item?.rack_details?.system_type || 'ife'}
                        size="small"
                        color="secondary"
                      />
                    </Stack>
                    <Stack direction="row" spacing={4}>
                      <Typography variant="caption" color="gray">
                        date created: {fDateTimeSuffix(item.created_at) || 'n/a'}
                      </Typography>
                      <Typography variant="caption" color="gray">
                        created by: {item.created_by || 'n/a'}
                      </Typography>
                    </Stack>
                  </Stack>
                }
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}
